import type { Clock, CorePorts, IdGen } from '@aj/core';
import { monotonicFactory } from 'ulid';

/**
 * The web implementations of @aj/core's ports.
 *
 * This is the boundary where ambient state is allowed to exist. Core itself
 * never calls `Date.now()` or `Math.random()` — it receives these, which is
 * what makes replay deterministic and lets tests substitute a fake clock.
 */

export const systemClock: Clock = {
  now: () => Date.now(),
  /**
   * `getTimezoneOffset()` returns minutes *west* of UTC; we store minutes
   * east, so Dhaka reads +360 rather than -360. Sampled at the given instant
   * rather than "now", so backfilled events get the offset that was actually
   * in effect.
   */
  utcOffsetMinutes: (atMs: number) => -new Date(atMs).getTimezoneOffset(),
  timeZone: () => Intl.DateTimeFormat().resolvedOptions().timeZone,
};

/** Monotonic within a millisecond, so rapid taps can't collide. */
const nextUlid = monotonicFactory();

export const ulidGen: IdGen = {
  ulid: (atMs: number) => nextUlid(atMs),
};

export const webPorts: CorePorts = { clock: systemClock, id: ulidGen };
